import { SET_PAGE_LANGUAGE } from './constants';

export const setPageLanguage = (language) => (dispatch, state) => {
    dispatch({
        type: SET_PAGE_LANGUAGE,
        language,
    });
};